import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useI18next, useTranslation, Link } from "gatsby-plugin-react-i18next";
import {
  MainNav,
  LogoContainer,
  PageList,
  NonLinkButton,
  NavMenuContainer,
} from "./styles";
import Hamburger from "components/Hamburger/Hamburger";
import { BetterLanguageSelector } from "./LanguageSelector";

//TODO: Make a global clear link and/or list styled components
const NavBar = ({ shadowed }) => {
  const { t } = useTranslation();
  const { language: currentLanguage, languages } = useI18next();
  const menuRef = useRef();
  const handleMenuToggle = useCallback(
    (e) => {
      menuRef.current.toggle(e);
    },
    [menuRef]
  );
  const handleContactsShow = useCallback((e) => {
    e.preventDefault();
    menuRef.current.hide();
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  }, []);
  const links = useMemo(
    () => [
      {
        to: "/",
        label: t("Home"),
      },
      {
        to: "/news",
        label: t("News"),
      },
      {
        to: "/help-an-animal-in-need",
        label: t("HelpAnAnimalInNeed"),
      },
      {
        label: t("Contacts"),
        onClick: handleContactsShow,
      },
    ],
    [t, handleContactsShow]
  );

  const pageListLinks = links.map((link, i) => (
    <li key={i}>
      {link.to ? (
        <Link
          role="menuitem"
          language={currentLanguage}
          activeClassName="link-active"
          to={link.to}
          onClick={link.onClick}
        >
          {link.label}
        </Link>
      ) : (
        <NonLinkButton role="menuitem" onClick={link.onClick}>
          {link.label}
        </NonLinkButton>
      )}
    </li>
  ));

  return (
    <MainNav shadowed={shadowed}>
      <LogoContainer>
        <Link language={currentLanguage} to="/">
          <StaticImage src={"../../images/logo.png"} alt="Logo" />
        </Link>
      </LogoContainer>
      <NavMenuContainer>
        <PageList className="">
          {pageListLinks}
          <BetterLanguageSelector
            languages={languages}
            currentLanguage={currentLanguage}
          />
        </PageList>
        <PageList>
          <Hamburger menuRef={menuRef} onMenuToggle={handleMenuToggle}>
            <PageList mobile>{pageListLinks}</PageList>
          </Hamburger>
          <BetterLanguageSelector
            languages={languages}
            currentLanguage={currentLanguage}
          />
        </PageList>
      </NavMenuContainer>
    </MainNav>
  );
};

export default NavBar;
